import { IconButton, SxProps, Theme, Tooltip, TooltipProps } from '@mui/material';
import { ElementType, ReactNode } from 'react';
import { ICONS } from '@/assets/icons';
import { PTypography } from '@/components/atoms/Typography/PTypography';
import Iconify from '@/components/Iconify';

interface Props {
  text: ReactNode;
  maxwidth?: number;
  sx?: SxProps<Theme>;
  placement?: TooltipProps['placement'];
  textColor?: string;
  iconStyle?: 'outlined' | 'contained';
  /**
   * Element the trigger renders as. Defaults to a `<button>` (IconButton's default). Pass
   * `"span"` when this tooltip sits inside another interactive element (e.g. a MUI Tab) to
   * avoid an invalid `<button>`-in-`<button>` nesting — the trigger is non-interactive anyway
   * (ripple disabled, default cursor), so a span is the correct element there.
   */
  component?: ElementType;
}

const InfoTooltip = ({
  text,
  maxwidth = 500,
  sx,
  placement = 'bottom-start',
  textColor = 'text.primary',
  iconStyle = 'outlined',
  component,
}: Props) => {
  return (
    <Tooltip
      title={
        <PTypography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
          {text}
        </PTypography>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: textColor,
            py: 1,
            px: 2,
            maxWidth: maxwidth,
            zIndex: 0, // Fix Safari overflow: hidden with border radius
          },
        },
      }}
      placement={placement}
    >
      <IconButton {...(component ? { component } : {})} disableRipple sx={{ cursor: 'default', ...sx }}>
        <Iconify icon={iconStyle === 'outlined' ? ICONS.INFO : ICONS.INFO_CONTAINED} width={20} height={20} />
      </IconButton>
    </Tooltip>
  );
};

export default InfoTooltip;
